export default function (editor) {
  const richTextEditor = editor.options.get("richTextEditor");
  (function init() {
    richTextEditor.plugins["plaintext"] = {
      renderInEditor,
      cleanUp,
      containPluginElements,
    };
  })();

  function renderInEditor() {}

  function cleanUp(content) {
    let strippedContent = content.replace(/\n+/g, "").trim();
    return strippedContent;
  }

  function containPluginElements() {
    return false;
  }
}
